module.exports = __webpack_public_path__ + "static/media/icons-split-screen-select.2334b641.svg";